import { render } from "./ConvertedToEmailNotice.vue?vue&type=template&id=4994577b"
import script from "./ConvertedToEmailNotice.vue?vue&type=script&lang=js"
export * from "./ConvertedToEmailNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__